
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/Routers/root"
import { CheckBox, CheckStyles, ProgressCircle } from "../.."
import { colors, fonts, Units, useUnitsComponent } from "../../../Styles";

import { TestData as ReportData } from "../../../Assets/TestData/reportTemplates";
import { TestData as milestones } from "../../../Assets/TestData/milestones";
import { TestData as Pens } from '../../../Assets/TestData/lf_Data';
import { TestData as AnimalData, myChosenFilters } from '../../../Assets/TestData/animalData';

import ReportShortCutCopy from "../../Reports/reportShortCut copy";
import Widget2 from "../../BaseComponents/widget copy 2";

/**
 * Farrowing
 * @returns A widget widt farrowing calendar.
 */
export default function Farrowing() {
  const {t} = useTranslation();
  const navigator = useNavigate()
  const getUnit = useUnitsComponent();

  const milestonesToShow = { milestones: [{milestoneId: 1}, {milestoneId: 2}] }
  
  const filtersToShow = { filters: [{filtersId: 1}, {filtersId: 2}]}

  const totalNumberOfAnimals = Pens.filter((pen) => pen.animalId).length;

  const getFilterName = (filtersId: number) => {
    const filter = myChosenFilters.find(filter => filter.filtersId === filtersId);
    return filter ? filter.filterName : "";
  };

  const getMilestoneName = (milestoneId: number) => {
    const milestone = milestones.find((m) => m.milestoneId === milestoneId);
    return milestone ? milestone.milestoneName : "No name Milestone";
  };

  const isMilestoneChecked = (milestoneId: number) =>
    milestonesToShow.milestones.some(
      (m) => m.milestoneId === milestoneId
    );

  return(      
    <Widget2
      header={<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>Animals in Milestones</p>}
      onSave={() => (console.log("save"))} // TODO
      rightContent={ <>
        <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center"}}>{"Auto Reports"}</p>
        <div style={{backgroundColor: colors.greySecondary, width: "100%", height: "2px"}}/>
          {filtersToShow.filters.map((filter, index) => (
            <ReportShortCutCopy
              key={index}
              header={getFilterName(filter.filtersId)}
              amount={0}
              onClick={() => RootNavigation(navigator, Pages.animals, undefined, true, { selected: filter.filtersId })
              }
            />
          ))}
      </> }

      leftContent={ <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridAutoRows: "auto", height: "100%", width: "100%", gap: "30px"}}>
        {milestonesToShow.milestones.map((milestone, index) => {
          const progressedAnimals = Pens.filter((pen) => {
            const animal = AnimalData.find((animal) => animal.animalId === pen.animalId);
            return animal && animal.milestoneId === milestone.milestoneId;
          });

          return (
            <ProgressCircle
              key={index}
              header={getMilestoneName(milestone.milestoneId)}
              unit={getUnit(Units.animalTotal_grey)}
              progressed={progressedAnimals.length}
              total={totalNumberOfAnimals}
            />
          );
        })}
      </div> }

      editMode={{
        editLeftContent: ( <>
          <div style={{display: "grid", gridTemplateColumns: "repeat(1fr)", gridAutoRows: "auto", width: "100%", height: "100%", gap: "10px 30px", overflowY: "scroll", scrollbarColor: colors.greyTertiary+colors.transparent, scrollbarWidth: "thin" }}>
            {milestones.map((milestone, eventIndex) =>
              <CheckBox
                key={eventIndex}
                text={milestone.milestoneName}
                isChecked={isMilestoneChecked(milestone.milestoneId)}
                checkStyle={CheckStyles.grey}
              />
            )}
          </div> 
        </> )
      }}
    />
  )
}